import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import StorageFileApi from './packages/StorageFileApi';
import StorageBucketApi from './packages/StorageBucketApi';
export var StorageClient = /*#__PURE__*/function (_StorageBucketApi) {
  _inherits(StorageClient, _StorageBucketApi);
  function StorageClient(url) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fetch = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, StorageClient);
    return _possibleConstructorReturn(this, _getPrototypeOf(StorageClient).call(this, url, headers, fetch));
  }
  /**
   * Perform file operation in a bucket.
   *
   * @param id The bucket id to operate on.
   */
  _createClass(StorageClient, [{
    key: "from",
    value: function from(id) {
      return new StorageFileApi(this.url, this.headers, id, this.fetch);
    }
  }]);
  return StorageClient;
}(StorageBucketApi);